import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useLayout } from "../../../providers/LayoutProvider";

// components
import Itinerary from "../components/Itinerary";
import { useSegmentsRepo } from "../db/useSegmentsRepo";
import { useTalesRepo } from "../db/useTalesRepo";

import ViewsHeader from "../components/ViewsHeader";
import ViewsFooter from "../components/ViewsFooter";

//icons
// import { Search } from "lucide-react";

// Main ItineraryPage Component
const ItineraryPage = () => {
  const segmentRepo = useSegmentsRepo();
  const talesRepo = useTalesRepo();
  // use setters from LayoutProvider to set display and/or set header footer content
  const { setHeaderContent, setFooterContent } = useLayout();
  const { setShowHeader, setShowFooter } = useLayout();
  const [taleSegments, setTaleSegments] = useState([]);
  const [tale, setTale] = useState([]);

  const { taleId } = useParams();
  const [activeFilters, setActiveFilters] = useState({
    transportation: true,
    accommodation: true,
    activity: true,
    tracks: true,
  });

  const handleToggleFilter = (type) => {
    const newState = !activeFilters[type];

    setActiveFilters((prev) => ({
      ...prev,
      [type]: newState,
    }));
  };

  // Mount/unmount header + footer
  useEffect(() => {
    // hide header on this page
    setShowHeader(true);
    // show footer on this page
    setShowFooter(true);

    // Optionally set custom chrome instead:
    setHeaderContent(<ViewsHeader tale={tale} taleId={taleId} />);
    setFooterContent(
      <ViewsFooter
        activeFilters={activeFilters}
        onToggleFilter={handleToggleFilter}
      />
    );

    //set HTML head title
    if (tale.title) document.title = `TOAT - ${tale.title} Timeline`;

    // cleanup runs on unmount, and on dependency changes
    return () => {
      setShowHeader(true);
      setShowFooter(true);
      setHeaderContent(null);
      setFooterContent(null);
    };
  }, [
    tale,
    activeFilters,
    setShowHeader,
    setShowFooter,
    setHeaderContent,
    setFooterContent,
  ]);

  // Load from JSON/DB
  useEffect(() => {
    // debug only
    // console.debug("Effect triggered", { taleId, segmentRepo });
    // if (!taleId) {
    //   console.debug("Waiting for taleId...");
    //   return;
    // }

    // if (!segmentRepo) {
    //   console.debug("Waiting for segmentRepo...");
    //   return;
    // }

    (async () => {
      const tale = await talesRepo.getById(taleId);
      setTale(tale);

      const segments = await segmentRepo.filterByIndex("taleId", taleId);
      setTaleSegments(segments);
    })();
  }, [taleId, segmentRepo, talesRepo]);

  //Filter list based on activeFilters
  const filteredSegments = useMemo(() => {
    return taleSegments.filter((seg) => {
      // seg.type should be one of 'transportation', 'accommodation', 'activity', 'tracks'
      const key = seg.type;
      // if we don't recognize the type, just keep it
      if (!(key in activeFilters)) return true;
      return activeFilters[key];
    });
  }, [taleSegments, activeFilters]);

  return (
    <>
      <Itinerary items={filteredSegments} />
    </>
  );
};

export default ItineraryPage;
